export default ({ src }: { src: string }) => src